// extracted by css-extract-rspack-plugin
export default {"userTable":"userTable-JcB7e5","userStatusDropdown":"userStatusDropdown-RzbY6d base-JkzNCZ","resultCount":"resultCount-OpkgtF"};